import { render, staticRenderFns } from "./Tumi.vue?vue&type=template&id=0be58255&scoped=true&"
import script from "./Tumi.vue?vue&type=script&lang=js&"
export * from "./Tumi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be58255",
  null
  
)

export default component.exports